/* unplugin-vue-components disabled */import script from "./applications-overview.vue?vue&type=script&lang=js"
export * from "./applications-overview.vue?vue&type=script&lang=js"

import "./applications-overview.vue?vue&type=style&index=0&id=209f9222&lang=scss"

const __exports__ = script;

export default __exports__